<template>
  <AppLayout title="Vendas">
    <div class="table-card">
      <table class="table">
        <thead>
          <tr>
            <th>Cliente</th>
            <th>Data</th>
            <th>Pagamento</th>
            <th>Valor</th>
            <th><i class="bi bi-info-square-fill"></i></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="venda in lista_vendas" :key="venda.id">
            <td>{{ venda.customer?.name ?? 'Avulso' }}</td>
            <td>{{ formaterService.dateTime(venda.date) }}</td>
            <td>{{ venda.payment_method?.name ?? formaterService.payment(venda.payment) }}</td>
            <td>
              {{ formaterService.currency(venda.value) }}
              <span v-if="venda.canceled_at" class="badge bg-danger ms-1">Cancelada</span>
            </td>
            <td style="width:40px">
              <router-link :to="{ name: 'sale-detail', params: { id: venda.id } }" class="btn btn-info btn-sm" title="Ver detalhes da venda">
                <i class="bi bi-info-square-fill"></i>
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Paginação -->
    <nav aria-label="Paginação de vendas" class="mt-3">
      <ul class="pagination justify-content-center">
        <li class="page-item" :class="{ disabled: currentPage === 1 }">
          <button class="page-link" @click="changePage(currentPage - 1)" :disabled="currentPage === 1">
            <i class="bi bi-chevron-left"></i> Anterior
          </button>
        </li>
        <li class="page-item" v-for="p in pages" :key="p" :class="{ active: p === currentPage }">
          <button class="page-link" @click="changePage(p)">{{ p }}</button>
        </li>
        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
          <button class="page-link" @click="changePage(currentPage + 1)" :disabled="currentPage === totalPages">
            Próximo <i class="bi bi-chevron-right"></i>
          </button>
        </li>
      </ul>
      <p class="text-center text-muted" style="font-size: 0.85rem;">
        Página {{ currentPage }} de {{ totalPages }} &mdash; {{ totalVendas }} vendas
      </p>
    </nav>
  </AppLayout>
</template>
<script>
  import AppLayout from "@/components/AppLayout.vue";
  import { onMounted, reactive, ref, computed } from 'vue';
  import { seles } from "@/models/seles";
  import { Modal } from "bootstrap";
  import formaterService from "@/services/formaterService";

  export default {
    name: 'SalesView',
    components: {
      AppLayout
    },
    setup(props) {
      const lista_vendas = ref([]);
      const Vendas = seles();

      // Variáveis de paginação
      const currentPage = ref(1);
      const totalPages = ref(1);
      const totalVendas = ref(0);
      const perPage = ref(11);

      // Computed: gera array de páginas para os botões
      const pages = computed(() => {
        const p = [];
        for (let i = 1; i <= totalPages.value; i++) {
          p.push(i);
        }
        return p;
      });

      const changePage = (page) => {
        if (page < 1 || page > totalPages.value) return;
        currentPage.value = page;
        listVendas(page);
      }

      const listVendas = async (page = 1) => {
        const retorno = await Vendas.list(page);
        if (retorno) {
          lista_vendas.value = retorno.data;
          totalPages.value = retorno.pages || 1;
          currentPage.value = retorno.page || 1;
          totalVendas.value = retorno.total || 0;
          perPage.value = retorno.perPage || 11;
        }
      }

      onMounted(function () {
        listVendas();
      });

      return {
        lista_vendas,
        // Paginação
        currentPage,
        totalPages,
        totalVendas,
        perPage,
        pages,
        changePage,
        formaterService
      }
    },
  }
</script>
